<template>
    <internal>
        <div
            class="p-6 bg-white border-b relative border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg"
        >
            <p class="text-lg font-medium absolute">List Week Schedules</p>
            <breeze-table
                :searchable="true"
                :fields="fields"
                :items="weekschedules"
                :action="{
                    text: 'add Schedule',
                    url: route('internal.weekschedule.create', branchid),
                }"
                :canView="
                    this.$page.props.auth.user.role.permissions.find(
                        (permission) => permission.name === 'View Schedule'
                    )
                "
                :canCreate="
                    this.$page.props.auth.user.role.permissions.find(
                        (permission) => permission.name === 'Create Schedule'
                    )
                "
            >
                <template #action_buttons>
                    <div class="w-56">
                        <FormMultiselect
                            @change="
                                (val) => {
                                    let query = makeParameter({
                                        course: val ?? null,
                                        year: null,
                                        batch: null,
                                    });
                                    $inertia.visit(
                                        `${route(
                                            'internal.weekschedule.list',
                                            branchid
                                        )}${query}`
                                    );
                                }
                            "
                            :required="true"
                            :options="courses"
                            track-key="title"
                            label-key="title"
                            :object="false"
                            v-model="filterForm.course_id"
                            :error="filterForm.errors.course_id"
                            returnValue="id"
                            placeholder="Select Course"
                        />
                    </div>
                    <div class="w-36">
                        <FormMultiselect
                            @change="
                                (val) => {
                                    let query = makeParameter({
                                        year: val ?? null,
                                        batch: null,
                                    });
                                    $inertia.visit(
                                        `${route(
                                            'internal.weekschedule.list',
                                            branchid
                                        )}${query}`
                                    );
                                }
                            "
                            :required="true"
                            :options="years"
                            track-key="title"
                            label-key="title"
                            :object="false"
                            v-model="filterForm.course_year_id"
                            :error="filterForm.errors.course_year_id"
                            returnValue="id"
                            placeholder="Select year"
                        />
                    </div>
                    <div class="w-36">
                        <FormMultiselect
                            @change="
                                (val) => {
                                    let query = makeParameter({
                                        batch: val ?? null,
                                    });
                                    $inertia.visit(
                                        `${route(
                                            'internal.weekschedule.list',
                                            branchid
                                        )}${query}`
                                    );
                                }
                            "
                            :required="true"
                            :options="batches_options"
                            track-key="title"
                            label-key="title"
                            :object="false"
                            v-model="filterForm.batch_id"
                            :error="filterForm.errors.batch_id"
                            returnValue="id"
                            placeholder="Select Batch"
                        />
                    </div>
                </template>

                <template #duration="data">
                    {{ data.item?.courseyear?.duration?.start_month }} -
                    {{ data.item?.courseyear?.duration?.end_month }}
                </template>
                <template #courseyear="data">
                    {{ data.item?.courseyear?.title }} -
                    {{ data.item?.courseyear?.course?.title }}
                </template>
                <template #semester="data">
                    {{ data.item.semester?.title }}
                </template>
                <template #batch="data">
                    {{ data.item.batch?.title }}
                </template>
                <template #status="data">
                    {{ data.item.status ? "Active" : "Inactive" }}
                </template>
                <template #action="data">
                    <button-link
                        :href="
                            route('internal.weekschedule.students', [
                                branchid,
                                data.item.id,
                            ])
                        "
                        :class="'mb-1 mr-2'"
                        v-if="
                            this.$page.props.auth.user.role.permissions.find(
                                (permission) =>
                                    permission.name === 'View Schedule'
                            )
                        "
                        >Attendance</button-link
                    >
                    <button-link
                        :href="
                            route('internal.weekschedule.schedule.show', [
                                branchid,
                                data.item.id,
                            ])
                        "
                        :class="'mb-1 mr-2'"
                        v-if="
                            this.$page.props.auth.user.role.permissions.find(
                                (permission) =>
                                    permission.name === 'View Schedule'
                            )
                        "
                        >Schedule</button-link
                    >
                    <button-link
                        :href="
                            route('internal.weekschedule.edit', [
                                branchid,
                                data.item.id,
                            ])
                        "
                        :class="'mb-1'"
                        v-if="
                            this.$page.props.auth.user.role.permissions.find(
                                (permission) =>
                                    permission.name === 'Edit Schedule'
                            )
                        "
                        >Edit</button-link
                    >
                </template>
            </breeze-table>
        </div>
    </internal>
</template>

<script>
import Internal from "@/Pages/Internal/Internal";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import ButtonLink from "@/Components/ButtonLink";
import CardHeader from "@/Components/CardHeader";
import { useForm } from "@inertiajs/inertia-vue3";
import BreezeInputError from "@/Components/InputError";
import BreezeButton from "@/Components/Button";
import BreezeCheckbox from "@/Components/Checkbox";
import Loading from "@/Components/Loading";
import SelectList from "@/Components/SelectList";
import Exception from "@/Components/Exception";
import BreezeTable from "@/Components/Table";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import { getParameters, makeParameter } from "../../../../Utils/Common";

export default {
    components: {
        Internal,
        FormMultiselect,
        BreezeInput,
        BreezeLabel,
        ButtonLink,
        CardHeader,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        Loading,
        Exception,
        BreezeTable,
        SelectList,
    },
    props: ["weekschedules", "years", "batches_options", "courses"],
    data() {
        return {
            fields: [
                { key: "duration", label: "Academic Year" },
                { key: "courseyear", label: "Course Year" },
                { key: "semester", label: "Semester" },
                { key: "batch", label: "Batch" },
                { key: "status", label: "Status" },
                { key: "action", label: "Action" },
            ],
            branchid: localStorage.branchId,
            filterForm: useForm({
                course_id: getParameters()?.course ?? null,
                course_year_id: getParameters()?.year ?? null,
                batch_id: getParameters()?.batch ?? null,
            }),
        };
    },
    methods: {
        makeParameter,
    },
};
</script>
